export const Opacity = {
  transparent: 0,
  low: 0.2,
  medium: 0.5,
  high: 0.9,
  opaque: 1,
} as const;

export type OpacityTokenType = keyof typeof Opacity;
